<script lang="ts" setup>
import type { FilePath } from '~/types'
import type { ApiMachineryPublicBaseSelect } from '~/layers/customer-module/types'

const props = defineProps<{ machinery?: ApiMachineryPublicBaseSelect | null, isLoading?: boolean }>()

const marketingPhotos = computed(() => props.machinery?.marketingPhotos ?? [])
const machineryMarketingVideos = computed(() => props.machinery ? (props.machinery.marketingVideos as FilePath[]).concat(props.machinery.externalMarketingVideos.map(path => ({ path }))) : [])

const isEmpty = computed(() => marketingPhotos.value.length === 0 && machineryMarketingVideos.value.length === 0)
</script>

<template>
  <CustomerModuleDataCard :title="$t('customerModule.machinery.details.gallery.title')">
    <template #headerExtra>
      <slot name="headerExtra" />
    </template>

    <CustomerModuleEmptyPlaceholder
      v-if="isEmpty"
      :title="$t('customerModule.machinery.details.gallery.empty.title')"
      icon-name="material-symbols:image-outline-rounded"
    />

    <div class="space-y-4">
      <FileView
        v-if="marketingPhotos.length > 0"
        :label="$t('customerModule.machinery.details.machinery.machineryPhotos')"
        :files="marketingPhotos"
        collapsed-by-default
      />
      <n-divider v-if="machineryMarketingVideos.length > 0" />
      <FileView
        v-if="machineryMarketingVideos.length > 0"
        :label="$t('customerModule.machinery.details.machinery.machineryVideos')"
        :files="machineryMarketingVideos"
        collapsed-by-default
      />
    </div>
  </CustomerModuleDataCard>
</template>
